import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    '& > div': {
      margin: '0'
    }
  },
  fullPageHeight: {
    height: '100%',
  },
  gridItem: {
    display: 'flex',
    justifyContent: 'center',
  },
  averRegLogoImgWrap: {
    maxWidth: 345,
    maxHeight: 85,
    transform: 'translate(10px, -140px)',
    '@media (min-height: 700px)': {
      transform: 'translate(10px, -100px)',
    }
  },
  averRegLogoImg: {
    minWidth: 280,
    width: '100%',
  },
}));
